export default "__VITE_ASSET__21b356ab__"